import React from 'react'
import HomeImg from '../../Assets/Images/Home.jpg'

const HomeLayout = () => {
  return (
    <div>
      <img className='h-[90vh] object-fill' src={HomeImg} alt="#" />
    </div>
  )
}

export default HomeLayout
